/**
 * Ce à quoi ressemble une référence de facture Sellsy.
 *
 * Deux formes en base : `FAC-20260923-39504`, et le numéro seul à cinq
 * chiffres (`39473`) des commandes plus anciennes. Tout le reste vient de la
 * boutique Shopify — `#MF…`, `#PS…`, `#BF…` — et n'a pas de facture Sellsy : y
 * chercher un règlement ne trouverait jamais rien.
 *
 * Une seule définition, pour que le relevé planifié, le bouton d'actualisation
 * et l'écran répondent la même chose à la même question.
 */
export const MOTIF_FACTURE_SELLSY = /^(?:FAC-|\d{5}$)/i;
export function estFactureSellsy(ref) {
    return MOTIF_FACTURE_SELLSY.test(String(ref ?? '').trim());
}
//# sourceMappingURL=sellsy.js.map